<div class="" *ngIf="isVmeMode">
  <p-dropdown
    [id]="organisationSelect"
    name="{{ formName }}"
    [options]="organisationsList"
    [showClear]="true"
    class="customers-select-list"
    [(ngModel)]="selectedOption"
    filter="true"
    optionLabel="label"
    (keyup)="onInputTextChanged($event)"
    (keydown.enter)="onSelectChange($event)"
    [ngModelOptions]="{ standalone: true }"
    (onChange)="onSelectChange($event)"
    placeholder="{{ selectPlaceHolderText }}"
  ></p-dropdown>
</div>
